<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on }">
      <v-btn depressed fab small dark :color="'#' + tour.color" v-on="on">{{ tour.identifier }}</v-btn>
    </template>
    <span>
      Tour: {{ tour.identifier }}<br>
      Datum: {{ tour.date }}<br>
      Name: {{ tour.name }}<br>
      Fahrzeug: {{ getVehicleTitle(tour.vehicle) }}<br>
      Orte: <span v-for="city in tour.namedCities" class="pr-2" :key="city">{{ city }}</span><br>
      Auslastung: {{ tour.weight }}/{{ tour.maxWeight }}
    </span>
  </v-tooltip>
</template>

<script>
export default {
  name: 'TourID',
  props: ['tour'],
  methods: {
    getVehicleTitle (vehicleId) {
      const vehicle = this.$store.state.vehicle.all.find(vehicle => vehicle.id === vehicleId)
      if (vehicle === undefined) {
        return ''
      }
      return vehicle.title
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/TourID.vue